import { render, staticRenderFns } from "./MedicinesCheck.vue?vue&type=template&id=44828d74"
import script from "./MedicinesCheck.js?vue&type=script&lang=js&external"
export * from "./MedicinesCheck.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports